// @ts-nocheck

(function () {
  function prefersHoverTooltip() {
    return (
      typeof window !== 'undefined' &&
      window.matchMedia &&
      window.matchMedia('(hover: hover) and (pointer: fine)').matches
    );
  }

  function populateAccessProgramDrawer(trigger) {
    const drawer = document.getElementById('mobile-drawer-access-program');
    if (!drawer || !trigger) return false;

    const titleEl = drawer.querySelector('#access-program-drawer-title');
    const programName =
      trigger.querySelector('.access-program-title')?.textContent.trim() ||
      trigger
        .querySelector('.access-program-text')
        ?.textContent.replace(/^Covered by\s+/i, '')
        .trim() ||
      'Follett Access';

    if (titleEl) {
      titleEl.replaceChildren();
      titleEl.append('This term is part of ');
      const nameSpan = document.createElement('span');
      nameSpan.className = 'access-program-title';
      nameSpan.textContent = programName;
      titleEl.appendChild(nameSpan);
    }

    return true;
  }

  function openAccessProgramDrawer(trigger) {
    if (!populateAccessProgramDrawer(trigger)) return;

    if (
      window.courseMaterialsSidebar &&
      typeof window.courseMaterialsSidebar.openMobileDrawerById === 'function'
    ) {
      window.courseMaterialsSidebar.openMobileDrawerById('mobile-drawer-access-program');
      return;
    }

    const drawer = document.getElementById('mobile-drawer-access-program');
    const backdrop = document.getElementById('mobile-drawer-backdrop');
    if (!drawer || !backdrop) return;

    backdrop.removeAttribute('hidden');
    drawer.removeAttribute('hidden');
    backdrop.classList.add('show', 'mobile-drawer-backdrop--access');
    drawer.classList.add('mobile-drawer-open');
    drawer.style.transform = 'translateY(0)';
    document.body.style.overflow = 'hidden';
    document.documentElement.classList.add('cmrp-scroll-lock');
  }

  function handleActivation(event) {
    if (prefersHoverTooltip()) return;

    const trigger = event.target.closest('.access-program-tooltip');
    if (!trigger) return;

    event.preventDefault();
    event.stopPropagation();
    openAccessProgramDrawer(trigger);
  }

  document.addEventListener('click', handleActivation);

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
      const drawer = document.getElementById('mobile-drawer-access-program');
      if (drawer?.classList.contains('mobile-drawer-open')) {
        window.courseMaterialsSidebar?.closeAccessProgramMobileDrawer?.();
      }
      return;
    }

    if (event.key !== 'Enter' && event.key !== ' ') return;
    if (prefersHoverTooltip()) return;

    const trigger = event.target.closest('.access-program-tooltip');
    if (!trigger) return;

    event.preventDefault();
    openAccessProgramDrawer(trigger);
  });

  window.openAccessProgramMobileDrawer = openAccessProgramDrawer;
})();
